(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dko-cyber-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var UNITS = ['d', 'h', 'm', 's'];

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }

    function init(root) {
      if (root.__dkoCd) { clearInterval(root.__dkoCd); }

      var start = Date.parse(root.dataset.start || '');
      var end = Date.parse(root.dataset.end || '');
      var msgEl = root.querySelector('[data-dko-cd-msg]');
      var timer = root.querySelector('.dko-cd__timer');
      var dayUnit = root.querySelector('[data-unit="d"]');
      var daySep = root.querySelector('[data-sep="d"]');
      var nums = {};
      UNITS.forEach(function (u) { nums[u] = root.querySelector('[data-dko-cd-' + u + ']'); });
      var hideDaysZero = root.dataset.hideDaysZero === '1';

      function setPhase(phase) {
        if (root.dataset.phase === phase) { return; }
        root.dataset.phase = phase;
        var key = 'msg' + phase.charAt(0).toUpperCase() + phase.slice(1);
        msgEl.textContent = root.dataset[key] || '';
      }

      function tick() {
        var now = Date.now();
        var target = NaN;
        var phase;

        if (!isNaN(start) && now < start) { phase = 'before'; target = start; }
        else if (!isNaN(end) && now < end) { phase = 'during'; target = end; }
        else { phase = 'after'; }

        setPhase(phase);

        if (phase === 'after') {
          timer.hidden = true;
          if (root.dataset.afterMode === 'hide') {
            if (designMode()) {
              msgEl.textContent = (root.dataset.msgAfter || 'Cyber terminado') + ' · (en la tienda esta cinta ya no se muestra)';
            } else {
              root.hidden = true;
            }
          }
          clearInterval(root.__dkoCd);
          return;
        }

        timer.hidden = false;
        var diff = Math.max(0, target - now);
        var totalSec = Math.floor(diff / 1000);
        var d = Math.floor(totalSec / 86400);
        var h = Math.floor((totalSec % 86400) / 3600);
        var m = Math.floor((totalSec % 3600) / 60);
        var sec = totalSec % 60;

        var showDays = !(hideDaysZero && d === 0);
        if (dayUnit) { dayUnit.hidden = !showDays; }
        if (daySep) { daySep.hidden = !showDays; }

        nums.d.textContent = pad(d);
        nums.h.textContent = pad(h);
        nums.m.textContent = pad(m);
        nums.s.textContent = pad(sec);
      }

      tick();
      root.__dkoCd = setInterval(tick, 1000);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-dko-countdown]').forEach(init);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
